{
  "advancededitor": {
    "Add entry": "Lägg till post",
    "Duplicate": "Duplicera",
    "Image attached": "Bild bifogad",
    "Inherit from wheel": "Ärva från hjulet",
    "Not shown on the wheel": "Visas inte på hjulet",
    "Popup message": "Popup-meddelande",
    "Shown on the wheel": "Visas på hjulet",
    "Weight": "Vikt"
  },
  "app": {
    "Ads": "Annonser",
    "Click here to report an inappropriate ad": "Klicka här för att rapportera en olämplig annons.",
    "Click the Language menu": "Klicka på menyn uppe till höger för att växla till svenska",
    "Close ad": "Stäng annonsen",
    "Common questions about using the random name picker wheel": "Vanliga frågor om att använda det slumpmässiga namnväljarhjulet",
    "Copy this wheel": "Kopiera detta hjul",
    "Create your own": "Skapa din egen",
    "Error": "Fel",
    "Free and easy to use": "Gratis och lätt att använda. Används av lärare och för lotterier. Ange namn och snurra hjulet för att välja en slumpmässig vinnare. Anpassa utseende och känsla, spara och dela hjul.",
    "Frequently Asked Questions": "Vanliga frågor",
    "It looks like you are using Internet Explorer": "Det verkar som att du använder Internet Explorer. Den webbläsaren kommer snart att sluta ta emot säkerhetsuppdateringar från Microsoft. Detta utsätter dig och oss för stora risker.\nSnart kommer du inte att kunna använda den här webbplatsen med Internet Explorer. Ladda ner en annan webbläsare genom att göra en onlinesökning efter \"ladda ned webbläsare\". Alla moderna webbläsare fungerar, till exempel Chrome, Firefox eller Edge.",
    "Loaded default names and options": "Standard-namn och bilder inladdade",
    "Random name picker": "Slumpmässig namnväljare",
    "Removed": "{name} har tagits bort",
    "Removing winner in": "Tar bort vinnaren om {seconds} sekunder",
    "Report bad ad": "Rapportera dålig annons",
    "Warning": "Varning",
    "We try to display only legitimate and honest ads": "Vi försöker visa endast legitima och ärliga annonser.",
    "authError": "Det fungerade inte. Försök igen och du blir ombedd att logga in. Om det fortfarande inte fungerar, prova dessa saker: uppdatera sidan med Ctrl + Shift + R (Windows, Linux, Chromebook) eller Command + Shift + R (Mac), stäng av din ad-blockerare, stäng av ditt antivirusprogram. \n\n({error})"
  },
  "faq": {
    "How do I use this app": "Hur använder jag denna app",
    "This app lets you spin a wheel": "Den här appen låter dig snurra ett hjul",
    "Can I save my wheel": "Kan jag spara mitt hjul",
    "Yes, if you create an account": "Ja, om du skapar ett konto",
    "Is this app free": "Är denna app gratis",
    "Yes, this app is completely free": "Ja, denna app är helt gratis"
  },
  "appInfo": {
    "Terms of service": "Användarvillkor",
    "Version": "Version"
  },
  "common": {
    "Cancel": "Avbryt",
    "Close": "Stäng",
    "Continue": "Fortsätt",
    "Customize": "Anpassa",
    "Delete": "Radera",
    "Edit description": "Redigera beskrivning",
    "Edit title": "Redigera titel",
    "Edit title and description": "Redigera titel och beskrivning",
    "If you dont see a Google login button below": "Om du inte ser en Google-inloggningsknapp nedan beror det förmodligen på att du använder en annonsblockerare som felaktigt tror att knappen är en annons.",
    "Link Google Account": "Länka Google-konto",
    "Link Google Sheet": "Länka Google-ark",
    "Link Google Spreadsheet": "Länka till Google-kalkylark",
    "My account": "Mitt konto",
    "OK": "OK",
    "Open": "Öppna",
    "Privacy policy": "Integritetspolicy",
    "Report offensive content": "Rapportera stötande innehåll",
    "Save": "Spara",
    "Sign in with Google": "Logga in med Google",
    "Sign in": "Logga in",
    "Create account": "Skapa konto",
    "or": "eller",
    "Email": "E-post",
    "Password": "Lösenord",
    "Display name": "Visningsnamn",
    "Display name is required": "Visningsnamn är obligatoriskt",
    "Sign in instead": "Logga in i stället",
    "Use this in the classroom": "Använd detta i klassrummet",
    "We have a winner!": "Vi har en vinnare!",
    "Wheel description": "Hjulbeskrivning",
    "Wheel title": "Hjultitel",
    "Max": "Max",
    "Move down": "Flytta ned",
    "Move up": "Flytta upp"
  },
  "nameTabs": {
    "Clear the list": "Rensa listan",
    "Entries": "Poster",
    "Hide": "Dölj",
    "Results": "Resultat"
  },
  "opendialog": {
    "Are you sure": "Är du säker på att du vill radera \"{wheelTitle}\"? Den här åtgärden kan inte ångras.",
    "Delete wheel": "Radera hjul",
    "No wheels found": "Inga hjul hittades i ditt konto. Prova att spara ett hjul!",
    "Open wheel": "Öppna hjul",
    "To open wheels": "Du behöver vara inloggad för att kunna öppna ett hjul.\nVänligen välj inloggningsmetod nedan."
  },
  "optionsdialog": {
    "After spin": "Efter snurr",
    "All names in the text-box": "Alla namn i textrutan har samma chans att vinna, oavsett detta värde.",
    "Animate winning entry": "Animera vinnarens namn",
    "Appearance": "Utseende",
    "Apply a theme": "Använd ett tema",
    "Auto-remove winner after 5 seconds": "Radera automatiskt vinnaren efter 5 sekunder",
    "Background color": "Sidans bakgrundsfärg",
    "Center text": "Text i mitten",
    "Colors": "Färger",
    "Colors tooltip": "Klicka på färgrutorna för att ändra dem",
    "Contours": "Konturer",
    "Custom": "Personalisera",
    "Customize colors": "Anpassa färger",
    "Disabled because the entries": "Inaktiverad eftersom posterna har olika vikt",
    "Display Hide button": "Visa knappen \"Göm\"",
    "Display Remove button": "Visa knappen \"Ta bort\"",
    "Display duplicates": "Visa dubbletter",
    "Display every entry": "Visa varje post i textrutan som en post på hjulet, även dubbletter",
    "Display popup with message:": "Visa popup med meddelandet:",
    "During spin": "Under snurr",
    "From Gallery": "Från Galleri",
    "Image": "Bild",
    "Image in the center of the wheel": "Bild i mitten på hjulet",
    "Image size": "Bildstorlek",
    "Launch confetti": "Kasta konfetti",
    "Max names on wheel": "Max antal namn på hjulet",
    "No": "Nej",
    "One color": "En färg per sektion",
    "Options": "Alternativ",
    "Pick category": "Välj kategori",
    "Pick theme": "Välj tema",
    "Play click sound when the winner is removed": "Spela ett klickljud när vinnaren tas bort",
    "Remove image": "Ta bort bilden",
    "Select a gallery picture": "Välj galleribild",
    "Show title": "Visa titel",
    "Sound": "Ljud",
    "Spin slowly": "Snurra långsamt",
    "Spin time (seconds)": "Snurr tid (sekunder)",
    "Text": "Text",
    "Upload image": "Ladda upp bild",
    "Volume": "Volym",
    "Wheel background image": "Hjul bakgrundsbild",
    "Yes": "Ja",
    "Your image has been uploaded": "Din bild '{fileName}' har laddats upp. Vill du använda de framträdande färgerna från den här bilden för sektorerna på ditt hjul?",
    "Advanced mode is enabled": "Avancerat läge är aktiverat",
    "Sounds": "Ljud",
    "Behavior": "Beteende",
    "Effects": "Effekter",
    "Color": "Färg"
  },
  "profiledropdown": {
    "Are you sure you want to delete your account": "Är du säker på att du vill radera ditt konto och alla dina sparade hjul? Den här åtgärden kan inte ångras.",
    "Delete account": "Radera konto",
    "Delete my account": "Radera mitt konto",
    "Export my data": "Exportera mina data",
    "Sign out": "Logga ut",
    "Signed out": "Utloggad",
    "Signed in as": "Inloggad som {name}",
    "Anonymous user": "Anonym användare",
    "Welcome new user": "Välkommen till Spin the Names! Ditt konto har skapats.",
    "Signed in success": "Inloggad framgångsrikt!",
    "Your account and your saved wheels have been deleted": "Ditt konto och dina sparade hjul har raderats"
  },
  "savedialog": {
    "Save as": "Spara som",
    "Save wheel": "Spara hjul",
    "Select a wheel": "Välj ett hjul",
    "Sorry, too many images": "Tyvärr, det här hjulet har för många bilder för att sparas i databasen. Minska antalet bilder och försök spara igen.",
    "To save wheels": "För att spara hjul måste du logga in på ett konto.\nVälj inloggningsmetod nedan.",
    "Wheel saved successfully": "Hjul \"{wheelTitle}\" sparat",
    "You will always be able to access": "Du kommer alltid att kunna komma åt dina sparade hjul så länge du öppnar eller sparar ett hjul minst en gång var tolfte månad.",
    "Your existing wheels": "Dina existerande hjul"
  },
  "sharedialog": {
    "Copy link": "Kopiera länk",
    "Created": "Skapad",
    "If you continue": "Om du fortsätter, skapar du en offentlig länk till ditt aktuella hjul, inklusive dess namn, färger och inställningar.",
    "Last viewed": "Senast visat",
    "Link": "Länk",
    "Link copied to the clipboard": "Länk kopierad till urklipp",
    "Link to this wheel": "Länk till detta hjul med dessa namn, färger och inställningar:",
    "My shared wheels": "Mina delade hjul",
    "No wheels found": "Inga delade hjul hittades i ditt konto. Prova att dela ett hjul!",
    "See my shared wheels": "Se mina delade hjul",
    "Shareable link": "Delbar länk",
    "Show title to people": "Visa titeln för personer som använder din delade länk",
    "Sorry, too many images": "Tyvärr har detta hjul för många bilder för att kunna bli delat. Ta bort några bilder och försök igen.",
    "They should be able to spin the wheel and": "De ska kunna snurra hjulet och göra en kopia av det",
    "They should only be able to spin the wheel": "De ska bara kunna snurra hjulet",
    "This link will work for anyone": "Den här länken fungerar för alla och du kan dela den via e-post, webbplats, sociala medier etc. Oanvända länkar raderas efter 365 dagar.",
    "Visits": "Besök",
    "We want this website to be safe place for everyone": "Vi vill att denna webbplats ska vara säker plats för alla. Hjul som inte är familjevänliga och som strider mot användarvillkoren kommer att raderas.",
    "What should a person be able to do": "Vad ska en person kunna göra när de använder din delade länk?"
  },
  "sheetdialog": {
    "Column": "Kolumn",
    "First row": "Första raden",
    "Is a header and should not be imported": "Är en rubrik och ska inte importeras",
    "Link sheet": "Länka kalkylark",
    "Select a column": "Välj en kolumn",
    "Select a tab": "Välj en flik",
    "Selected spreadsheet": "Valt kalkylark",
    "Tab": "Flik",
    "To import sheets": "För att importera kalkylark måste du logga in på ditt Google-konto. Varför? Google behöver veta vem du är, så att de kan låta dig välja ett av dina kalkylark.",
    "When you link a spreadsheet": "När du länkar till ett kalkylark, kommer hjulet att ha samma information som kalkylarket. Om raderar, lägger till eller tar bort i kalkylarket, kommer de automatiskt att läggas till eller tas bort på hjulet. Anslutningen stängs efter en timme.",
    "added": "{entry} tillagd",
    "entries added": "{count} namn har lagts till"
  },
  "sounds": {
    "Alarm clock": "Väckarklocka",
    "Angel choir": "Änglakör",
    "Announcement bell": "Meddelandeklocka",
    "Applause": "Högljudda applåder",
    "Basketball buzzer": "Basket summer",
    "Bell ringing": "Klocka ringer",
    "Bird chirps": "Fågelkvitter",
    "Boing": "Boing",
    "Boing 2": "Boing 2",
    "Carnival shout": "Karnevalsrop",
    "Cartoon whistle": "Tecknad visselpipa",
    "Cat meow": "Katt jamar",
    "Childrens hooray": "Barnens hurra",
    "Cinematic drum impact": "Filmisk trumpåverkan",
    "Cinematic music": "Filmisk musik",
    "Correct answer ding": "Rätt svar ding",
    "Crash": "Krascha",
    "Cymbals": "Cymbaler",
    "Dog bark": "Hund skäll",
    "Drum roll": "Trumvirvel",
    "Easy listening": "Lättlyssnat",
    "Evil laugh": "Elakt skratt",
    "Fanfare": "Fanfar",
    "Fireworks": "Fyrverkeri",
    "Game win ding": "Spelet vinner",
    "Ghost": "Spöke",
    "Hooray": "Hurra",
    "Horror scream": "Skräckskrik",
    "Horse": "Häst",
    "Joke punchline": "Skämt punchline",
    "Lion roar": "Lion Roar",
    "Lost game": "Förlorat spel",
    "Microwave ding": "Mikrovågsugn",
    "Military trumpet": "Militär trumpet",
    "Mystery bell": "Mystisk klocka",
    "No sound": "Inget ljud",
    "Notification bell": "Meddelandeklocka",
    "Old phone ringing": "Gammal telefon ringer",
    "Pan flute": "Panflöjt",
    "Pop music": "Popmusik",
    "Random 8-Bit": "Slumpmässig 8-bitars",
    "Random ballroom dancing": "Slumpmässig sällskapsdans",
    "Random cinematic music": "Slumpmässig filmmusik",
    "Random dance & techno": "Random dance & techno",
    "Random disco": "Slumpmässigt disco",
    "Random easy listening": "Slumpmässig lättlyssning",
    "Random electronica": "Slumpmässig elektronik",
    "Random folk music": "Slumpmässig folkmusik",
    "Random funk": "Slumpmässig funk",
    "Random hip hop": "Slumpmässig hiphop",
    "Random music": "Slumpmässig musik",
    "Random polka": "Slumpmässig polka",
    "Random pop music": "Slumpmässig popmusik",
    "Random reggae & reggaeton": "Slumpmässig reggae & reggaeton",
    "Random retro-rock": "Slumpmässig retrorock",
    "Random rock music": "Slumpmässig rockmusik",
    "Random rockabilly": "Slumpmässig rockabilly",
    "Random silent film score": "Slumpmässig stumfilmsmusik",
    "Random winter holidays": "Slumpmässig jullovsmusik",
    "Random world music": "Slumpmässig världsmusik",
    "Read out the winning name": "Läs upp det vinnande namnet",
    "Read out the winning name (option 1)": "Läs upp det vinnande namnet (alternativ 1)",
    "Read out the winning name (option 2)": "Läs upp det vinnande namnet (alternativ 2)",
    "Referee whistle": "Domaren vissla",
    "Rock music": "Rockmusik",
    "Sad trombone": "Trist trombon",
    "Silent film score": "Stumfilmsmusik",
    "Sound effects": "Ljudeffekter",
    "Subdued applause": "Dämpade applåder",
    "Swoosh ding": "Swoosh ding",
    "Synth bell": "Synth bell",
    "Taiko drum": "Taiko trumma",
    "Thunder": "Åska",
    "Ticking sound": "Tickande ljud",
    "Twinkling star": "Blinkande stjärna",
    "Water splash": "Vattenplask",
    "Winter holidays": "Jullovsmusik",
    "Wolf howl": "Varg yl",
    "World music": "Världsmusik",
    "Xylophone ascending": "Xylofon stigande"
  },
  "spinningwheel": {
    "Click to spin": "Klicka för att snurra",
    "Tap to spin": "Klicka för att snurra",
    "or press ctrl+enter": "eller tryck ctrl+enter"
  },
  "textboxbuttons": {
    "Add image": "Lägg till bild",
    "Advanced": "Avancerad",
    "Revert from advanced": "Återgå",
    "Reverting will reset": "Om du återgår från avancerat läge kan du tappa några färger. Är du säker på att du vill fortsätta?",
    "Shuffle": "Blanda",
    "Sort": "Sortera"
  },
  "toolbar": {
    "Add your language": "Lägg till ditt språk",
    "Dark mode": "Mörkt läge",
    "Exit fullscreen": "Gå ur fullskärmsläge",
    "FAQ": "Frågor & Svar",
    "Feedback": "Respons",
    "Fullscreen": "Fullskärm",
    "Language": "Språk",
    "More": "Mer",
    "New": "Nytt",
    "Offline mode": "Offlineläge",
    "Please enter your email address": "Ange din e-postadress för att fortsätta",
    "Send debug data": "Skicka felsökningsdata",
    "Share": "Dela",
    "System theme": "Systemtema",
    "Theme settings": "Temainställningar",
    "Light theme": "Ljust tema",
    "Dark theme": "Mörkt tema",
    "Light": "Ljus",
    "Dark": "Mörk",
    "Currently using": "Använder för tillfället",
    "Theme": "Tema",
    "Unlink Google Spreadsheet": "Koppla bort Google-kalkylark",
    "User reviews and tutorials": "Användarrecensioner och handledning",
    "Your session is now being recorded": "Din session spelas in. Du kan stoppa inspelningen genom att stänga webbläsarfönstret."
  },
  "winnerdialog": {
    "Hide": "Dölj",
    "Remove": "Ta bort",
    "Remove all instances": "Ta bort alla"
  },
  "banner": {
    "setupMessage": "Hej där! Vi håller fortfarande på att sätta upp allt. Vissa funktioner kan vara begränsade eller tillfälligt otillgängliga. Tack för ditt tålamod!",
    "dismissLabel": "Stäng meddelande"
  },
  "accountdialog": {
    "Sign in intro": "Logga in för att spara, dela och hantera dina hjul.",
    "Preparing sign-in": "Förbereder inloggningsalternativ…",
    "Troubleshooting title": "Felsökning av inloggning",
    "Login failed": "Inloggningen misslyckades. Vänligen försök igen.",
    "Email verified": "E-post verifierad",
    "Email not verified": "E-post inte verifierad",
    "Resend verification email": "Skicka verifieringsmejl igen",
    "Verification email sent": "Verifieringsmejl skickat. Kontrollera din inkorg och skräppost.",
    "Verification email failed": "Det gick inte att skicka verifieringsmejlet. Försök igen senare."
  }
}
